import { z } from "zod";

import { DEFAULT_STATUS, STATUS_LABELS, STATUS_OPTIONS } from "../../../../utils/statusFilter";

export { STATUS_LABELS, STATUS_OPTIONS };

export const COMPETENCIES_PAGE_SIZE = 25;

export interface CompetenciesFilters {
	status: "active" | "archived" | "any";
	companyWide?: boolean;
}

export const DEFAULT_FILTERS: CompetenciesFilters = { status: DEFAULT_STATUS };

/**
 * Internal form shape for the filter panel. `companyWide` is always a real boolean here
 * so TanStack form state is simple; on submit we only surface `companyWide: true` to
 * the external `CompetenciesFilters` shape (`false` is treated as "not applied").
 */
export const CompetenciesFilterFormSchema = z.object({
	status: z.enum(["active", "archived", "any"]),
	companyWide: z.boolean(),
});

export type CompetenciesFilterForm = z.infer<typeof CompetenciesFilterFormSchema>;
